import { LOAD_TF_MODEL } from '../actions'

const INITIAL_STATE = {
    model: null,
}

function TensorflowModelReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOAD_TF_MODEL:
            return {
                ...state,
                model: action.payload,
            }
        default: return state
    }
}

export default TensorflowModelReducer



// WEBPACK FOOTER //
// ./src/reducers/tensorflowModels.js